import { Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import { CoreApiProvider } from "providers/CoreApiProvider";
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { SessionService } from "services/sessionService";

////////////////////////////////////////////////////////////////////////////////////////////////////////

const Container = styled('div')({
    zIndex: 2,
    position: "relative",
    height: "100vh"
});

const Page = styled('div')(({ theme }) => ({
    backgroundColor: "#e5e5e5",
    backgroundSize: "cover",
    backgroundPosition: "top center",
    height: "100vh",
}));

const PageHeader = styled('div')(({ theme }) => ({
    margin: "0",
    padding: "0",
    border: "0",
    height: "100vh"
}));

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    fullView?: boolean;
}

type Props = IAppProps & React.PropsWithChildren;

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicLayout: React.FC<Props> = (props) => {

    //const { fullView } = props;
    //const [loaded, setLoaded] = useState(true);
    //const [previousPath, setPreviousPath] = useState("");
    //const { config } = useSession();

    const location = useLocation();
    const [currentPath, setCurrentPath] = useState("");

    const mainPanel = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (location.pathname !== currentPath) {
            //setPreviousPath(currentPath);
            setCurrentPath(location.pathname);
            if (mainPanel && mainPanel.current) mainPanel.current.scrollTop = 0;
        }
    }, [currentPath, mainPanel, location.pathname]);

    return (
        <CoreApiProvider >
            <Page ref={mainPanel} style={{ backgroundImage: `url(${SessionService.current.appImages.backgroundUrl})` }}>
                <PageHeader>
                    <Container>
                        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }} >
                            <Grid size="grow">
                                <Outlet />
                            </Grid>
                        </Grid>
                    </Container>
                </PageHeader>
            </Page>
        </CoreApiProvider>
    );
};
